<template>
  <div :class="[question.Source?.toLowerCase()]">
    <div class="col-12 col-md-6 pa-0" :class="[question.StyleClass]">
      <HomeBaseLabel :question="question" />
      <v-autocomplete
        dense
        outlined
        :hide-details="
          question.HideDetails != null ? question.HideDetails : 'auto'
        "
        :data-uiid="question.DataUiid"
        placeholder="Start typing..."
        :items="orderByAZ"
        item-text="Description"
        item-value="Code"
        v-model="question.Value"
        @change="resetSource"
        :rules="getRules"
        ref="selectIndustry"
        :menu-props="{
          contentClass: isSelfServe
            ? 'd2c-autocomplete-dropdown'
            : 'autocomplete-dropdown',
        }"
        :aria-label="question.Text ?? ''"
      >
        <template v-slot:append>
          <v-icon v-if="$refs.selectIndustry?.valid" color="green" size="20"
            >mdi-check-circle</v-icon
          >
          <v-icon
            v-if="
              !$refs.selectIndustry?.valid && $refs.selectIndustry?.hasMessages
            "
            color="red"
            size="20"
            >mdi-alert-circle</v-icon
          >
        </template>
        <template v-slot:no-data>
          <v-list-item class="noHover">
            <v-list-item-content>
              <v-list-item-title>
                <p class="font-12 text-center ma-0">
                  <strong>Sorry!</strong> We couldn't find that industry in our
                  database, please check your spelling or try a different
                  industry type.
                </p>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-autocomplete>
    </div>
  </div>
</template>

<script>
import QuestionValidation from "@/Mixins/Validation/QuestionValidation";
import { sortAlpha } from "@/common/sorting";
import HomeBaseLabel from "@/components/HomeComponents/HomeBaseComponents/HomeBaseLabel";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { mapGetters } from "vuex";

export default {
  name: "SelectIndustry",
  mixins: [QuestionValidation],
  components: {
    HomeBaseLabel,
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["allIndustries", "isSelfServe"]),
    orderByAZ() {
      // Sort a clone of the array
      if (!this.allIndustries) return [];
      return this.allIndustries.map((x) => x).sort(sortAlpha);
    },
  },
  methods: {
    resetSource() {
      this.question.Source = "User";
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.v-text-field.v-text-field--enclosed .v-text-field__details) {
  padding-left: 0;
}
</style>
